var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.79267 9.96704H5.82295V20.6985H1.79438C1.68258 20.6987 1.57183 20.6769 1.46847 20.6342C1.36511 20.5916 1.27117 20.529 1.19203 20.45C1.11289 20.3711 1.05011 20.2772 1.00727 20.174C0.964432 20.0707 0.942383 19.96 0.942383 19.8482V10.8173C0.942383 10.5918 1.03197 10.3755 1.19143 10.2161C1.35089 10.0566 1.56716 9.96704 1.79267 9.96704Z",
    stroke: "#EFBC51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82324 9.96693L10.1432 3.06178C10.3107 2.78868 10.546 2.56363 10.8263 2.4086C11.1066 2.25356 11.4224 2.17384 11.7427 2.17721C11.9945 2.16828 12.2456 2.20986 12.4811 2.29952C12.7166 2.38918 12.9318 2.5251 13.114 2.69926C13.2961 2.87342 13.4415 3.08229 13.5417 3.31355C13.6418 3.54481 13.6946 3.79379 13.697 4.04578V8.99493H21.1644C21.4404 9.00369 21.7114 9.07084 21.9595 9.19195C22.2077 9.31306 22.4274 9.48539 22.6041 9.69758C22.7808 9.90976 22.9105 10.157 22.9848 10.423C23.059 10.6889 23.076 10.9676 23.0347 11.2406L21.6752 20.0161C21.6172 20.485 21.3898 20.9166 21.036 21.2298C20.6821 21.5429 20.2261 21.716 19.7535 21.7166H8.59524C8.06381 21.7184 7.54096 21.5966 7.0661 21.3601L5.84039 20.7481",
    stroke: "#EFBC51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82324 9.96704V20.6985",
    stroke: "#EFBC51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.7953d164d25f0632b268ce4bac618aee.svg";
export { ForwardRef as ReactComponent };